type ClassValue = string | false | null | undefined;

/** Склеивает классы, отбрасывая пустые значения. */
export const cx = (...values: ClassValue[]): string => values.filter(Boolean).join(' ');
